import React from "react";

import "./InfoCard.scss";

interface InfoCardProps {
  imgSrc: string;
  imgAlt: string;
  description: string;
}

const InfoCard = ({ imgSrc, imgAlt, description }: InfoCardProps) => {
  return (
    <div className="info-card">
      <img src={imgSrc} alt={imgAlt} className="info-card-image" />

      <div className="info-card-content">
        <p className="card-description">{description}</p>
      </div>
    </div>
  );
};

export default InfoCard;
